export default __webpack_public_path__ + "static/media/civislogoonly.c4a38aa7.png";